import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.clientAccount') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.clientAccount') }),
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.clientAccount') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.clientAccount') });
});